import FontFaceObserver from 'fontfaceobserver';
import P from 'bluebird';
import $ from 'jquery';
const $body = $('body');

export default function () {
    return P.all([
        'FCIcon2015',
        // 'Roboto',
        'FCGrumpy',
        'FCZizouSans',
        'FCKaiser',
        'FCKaiserLight',
        'FCKaiserMed',
        'FCKaiserBold',
        'FCKaiserCondExtraLight',
        'FCKaiserCond',
        'FCKaiserCondMed',
        'FCKaiserCondBold',
        'FCKaiserXCondExtraLight',
        'FCZizouSansBold',
        'FCZizouSans',
        'FCZizouSlabLight',
        'FCZizouSansMedium',
        // 'ColfaxBold',
        'MeretPro',
        'MeretProBold',
        'MeretProSemiBold',
        'MeretProItalic',
        'MeretProBoldItalic'
        // 'VideoJS'
    ].map(function loadInFont(fontName) {
        const font = new FontFaceObserver(fontName);
        return font.load();
    })).then(function allFontsLoaded() {
        // alert('fonts-loaded');
        $body.addClass('fonts-loaded');
    }).catch(function handleLoadingFontsError(/* err */) {
        // todo: log error here
        // console.error('Error loading fonts.', err);
        $body.addClass('fonts-loaded fonts-loaded-error');
    });
}
